import { render, staticRenderFns } from "./EditRelationNote.vue?vue&type=template&id=2e5d1558"
import script from "./EditRelationNote.vue?vue&type=script&lang=js"
export * from "./EditRelationNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports